<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card
        [advanceButton]="true"
        (outputButtonAdvance)="callFunction($event)"
        [advancedButtons]="specialButtons"
        [cardOptionBtnValue]="'menu.credit-invoice.view'|translate"
        [title]="'global.overview'|translate">
        <app-grid [grid]="grid" (sendParameters)="setParams($event)"></app-grid>
      </app-card>
    </div>
  </div>
</div>
<ng-template #amountPriceTemp let-row="row" let-value="value" let-column="column">
  <span *ngIf="row.isCredit">- </span>{{row.mockInvoice.amount  | BackofficeCurrency}}
</ng-template>
<ng-template #draftInvoiceDealer let-row="row" let-value="value" let-column="column">
  <span *ngIf="row.isCredit">- </span>{{row?.mockInvoice?.invoiceDealer?.companyName}}
</ng-template>
<ng-template #amountExPriceTemp let-row="row" let-value="value" let-column="column">
  <span *ngIf="row.isCredit">- </span>{{row.mockInvoice.amountEx  | BackofficeCurrency}}
</ng-template>



<app-modal-basic #creditInvoiceModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4 class="modal-title">
      {{'admin.backoffice.invoice.credit-invoice.modal-title'| translate }}
    </h4>
    <button type="button" class="close basic-close" (click)="creditInvoiceModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p [innerHTML]="'admin.backoffice.invoice.credit-invoice.are-you-sure'|translate:{invoicenumber: invoiceId}"></p>
    <p>{{'admin.backoffice.invoice.credit-invoice.choose-layout' | translate}}</p>
    <form novalidate #addCreditInvoiceForm="ngForm">
      <div class="form-group row">
        <div class="form-group form-default form-static-label col-6">
          <ng-select required name="type" id="type" [items]="templates" bindLabel="label" bindValue="value"
                     [(ngModel)]="selectedTemplate" [clearable]="false" [searchable]="false"></ng-select>
        </div>
      </div>

      <p>{{'admin.backoffice.invoice.credit-invoice-row'|translate }}</p>
      <hr class="mb-4">

      <ng-container *ngFor="let creditInvoiceItem of creditInvoiceItems; let i = index">
        <div class="form-row row">
          <div class="form-group col-md-6">
            <label [for]="'description' + i">{{"doctrine.backoffice.credit-invoice.description" | translate}}<span
              class="star">*</span></label>
            <input required [name]="'description' + i"
                   [id]="'description' + i"
                   class="form-control"
                   #description="ngModel"
                   [(ngModel)]="creditInvoiceItem.description">
            <span class="form-bar"></span>
            <div class="messages text-danger"
                 *ngIf="description.invalid && description.dirty && description.errors?.required">
              {{'errors.required'|translate}}
            </div>
          </div>
          <div class="form-group col-md-2">
            <label [for]="'amount' + i">{{"doctrine.backoffice.credit-invoice.amount" | translate}}   <span
              class="star">*</span></label>
            <input required [name]="'amount' + i"
                   type="number"
                   step="1"
                   min="1"
                   [id]="'amount' + i"
                   class="form-control"
                   #amount="ngModel"
                   [(ngModel)]="creditInvoiceItem.amount">
            <span class="form-bar"></span>
            <div class="messages text-danger"
                 *ngIf="amount.invalid && amount.dirty && amount.errors?.required">
              {{'errors.required'|translate}}
            </div>
            <div class="messages text-danger"
                 *ngIf="amount.errors?.min">
              {{'errors.positive_rang'|translate }}
            </div>
          </div>
          <div class="form-group col-md-3">
            <label [for]="'price' + i">{{"doctrine.backoffice.credit-invoice.price" | translate}} <span
              class="star">*</span></label>
            <input required [name]="'price' + i"
                   type="number"
                   step="0.01"
                   min="1"
                   [id]="'price' + i"
                   class="form-control"
                   #price="ngModel"
                   [(ngModel)]="creditInvoiceItem.price">
            <span class="form-bar"></span>
            <div class="messages text-danger"
                 *ngIf="price.invalid && price.dirty && price.errors?.required">
              {{'errors.required'|translate}}
            </div>
            <div class="messages text-danger"
                 *ngIf="price.errors?.min">
              {{'errors.positive_rang'|translate }}
            </div>
          </div>
          <div class="form-group col-md-2 mt-4" *ngIf="i !== 0">
            <a class="btn btn-lg btn-icon ripple light ms-1" (click)="removeCreditItem(i)">
              <i class="fa fa-trash trash-danger"></i>
            </a>
          </div>
        </div>
      </ng-container>
      <button class="btn btn-primary ripple light mb-0 mt-0" (click)="addCreditItem()">
        <i class="fa fa-plus"></i>
        &nbsp;{{'global.add' | translate}}
      </button>
    </form>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="hideModal()">{{'global.cancel'|translate}}</button>
    <button type="submit" class="btn btn-primary ripple light" (click)="onCredit()"
            [disabled]="!addCreditInvoiceForm.valid || disableCreditInvoiceBtn">
      {{(isEdit ? 'global.actions.save' : 'admin.backoffice.invoice.credit-invoice.modal-credit') | translate}}
    </button>
  </div>
</app-modal-basic>

<app-generate-invoice #createCustomInvoiceModal="generateInvoice" (resultInvoice)="onInvoiceGenerated ($event)"></app-generate-invoice>
